import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";

export default abstract class GetGameRequest implements IRequestBuilder {
    abstract get requestData();

    get path() {
        let domain =
            GameModel.apiConfig.domain ||
            window.location.protocol + "//" + window.location.hostname;
        let port = GameModel.apiConfig.port;
        let portString = port ? ":" + port : "";

        return domain + portString + "/game";
    }

    get method(): string {
        return "POST";
    }
}
